import { useState } from 'react';
import type { ProviderKind } from '@hangar/shared';
import type { ProviderAccount } from '@/api/schemas';

export interface SheetState {
  editing?: ProviderAccount;
  kind?: ProviderKind;
}

/** Which of the provider-account overlays is open: the connect/edit sheet, the replace-token dialog, the disable confirmation. */
export function useAccountDialogs() {
  const [sheet, setSheet] = useState<SheetState | null>(null);
  const [replacing, setReplacing] = useState<ProviderAccount | null>(null);
  const [disabling, setDisabling] = useState<ProviderAccount | null>(null);
  return { sheet, setSheet, replacing, setReplacing, disabling, setDisabling };
}

export type AccountDialogs = ReturnType<typeof useAccountDialogs>;
